export default __webpack_public_path__ + "static/media/ajk.17a76534.jpeg";